module.exports = __webpack_public_path__ + "static/3-e4b70de258c62fa52a9a6ab1f21cae7e.jpg";